export class AuthError {

}